<template>
  <div class="music-time-slider">
    <v-slider
      v-model="currentTime"
      min=0
      step=0.1
      :max="duration"
      :hide-details=false
      @click="slideBar"
    ></v-slider>
    <div class="music-time-slider__time">
      <span>{{ currentTime | minutes }}</span>
      <span>{{ duration | minutes }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MusicTimeSlider',
  data () {
    return {
      audio: undefined,
      currentTime: 0,
      duration: 0
    }
  },
  mounted () {
    this.audio = document.querySelector('#audio')
    const that = this
    this.audio.addEventListener('loadedmetadata', () => {
      that.currentTime = that.audio.currentTime
      that.duration = that.audio.duration
    })
    this.audio.addEventListener('timeupdate', () => {
      that.currentTime = that.audio.currentTime
    })
  },
  methods: {
    slideBar () {
      this.audio.currentTime = this.currentTime
    }
  }
}
</script>
<style lang="scss" scoped>
  .music-time-slider {
    width: 100%;
  }
  .music-time-slider__time {
    display: flex;
    justify-content: space-between;
  }
  /deep/ .input-group__details{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Organisms/MusicTimeSlider.vue